/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsControllerFindAllQueryResponse,
  TelegramProductsControllerFindAllQueryParams,
  TelegramProductsControllerFindAll401,
} from '../types/TelegramProductsControllerFindAll.ts';

function getTelegramProductsFindAllUrl() {
  const res = { method: 'GET', url: `/api/telegram/products` as const };
  return res;
}

/**
 * {@link /api/telegram/products}
 */
export async function telegramProductsFindAll(
  params?: TelegramProductsControllerFindAllQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsControllerFindAllQueryResponse,
    ResponseErrorConfig<TelegramProductsControllerFindAll401>,
    unknown
  >({ method: 'GET', url: getTelegramProductsFindAllUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
